import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { ChevronDownIcon } from 'primeng/icons/chevrondown';
import { ChevronRightIcon } from 'primeng/icons/chevronright';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { StarFillIcon } from 'primeng/icons/starfill';
import { StarIconStylesDirective } from '../../directives/star-icon-styles.directive';
import { IMenuItem, MenuItemModel } from '../../models/nav-item.model';
import { PanelMenuModule } from 'primeng/panelmenu';

export interface IStarIconActionPayload {
  menuItem: IMenuItem;
  event: Event;
}

@Component({
  selector: 'lh-panel-menu',
  standalone: true,
  templateUrl: './panel-menu.component.html',
  styleUrl: './panel-menu.component.scss',
  imports: [
    ChevronDownIcon,
    ChevronRightIcon,
    StarFillIcon,
    RouterLinkActive,
    RouterLink,
    StarIconStylesDirective,
    PanelMenuModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class PanelMenuComponent {
  @Input({ required: true }) menuItems: IMenuItem[] = [];
  @Input({ required: true }) favouriteSubmenu: MenuItemModel | null = null;
  @Output() readonly starIconClick: EventEmitter<IStarIconActionPayload> = new EventEmitter<IStarIconActionPayload>();

  get menu(): (IMenuItem | MenuItemModel)[] {
    return this.favouriteSubmenu ? [this.favouriteSubmenu, ...this.menuItems] : this.menuItems;
  }
}
